var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3C5.2 3 3 5.2 3 8V16C3 18.8 5.2 21 8 21H16C18.8 21 21 18.8 21 16V8C21 5.2 18.8 3 16 3H8ZM8 5H16C17.7 5 19 6.3 19 8V16C19 17.7 17.7 19 16 19H8C6.3 19 5 17.7 5 16V8C5 6.3 6.3 5 8 5ZM17 6C16.4 6 16 6.4 16 7C16 7.6 16.4 8 17 8C17.6 8 18 7.6 18 7C18 6.4 17.6 6 17 6ZM12 7C9.2 7 7 9.2 7 12C7 14.8 9.2 17 12 17C14.8 17 17 14.8 17 12C17 9.2 14.8 7 12 7ZM12 9C13.7 9 15 10.3 15 12C15 13.7 13.7 15 12 15C10.3 15 9 13.7 9 12C9 10.3 10.3 9 12 9Z",
    fill: "#7F86A4"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.3879b85983cda7244d07e343a1e528f7.svg";
export { ForwardRef as ReactComponent };